import {loadOrientations} from '../../modules/api/orientation.api';

export const getters = {
    orientations:        (state) => state.orientations,
    loadOrientationById: (state, getters) => (orientationId) => {
        return new Promise((resolve) => resolve(getters.orientations.find((orientation) => orientation.id === orientationId) || null));
    },
}

export const actions = {
    async loadOrientations({ commit }) {
        return loadOrientations().then((data) => commit('SET_ORIENTATIONS', data));
    },
}

export const mutations = {
    SET_ORIENTATIONS: (state, orientationsData) => state.orientations = orientationsData,
}
